import { type ReactNode } from "react";

/**
 * The bar pinned under a company panel that holds its actions — lists, CRM,
 * full page, assignee — whether the company is in base or not saved yet.
 */
export default function PanelActionsBar({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <div className="border-t border-border bg-background p-4">
      <div className="flex items-center gap-2">{children}</div>
    </div>
  );
}
